// @ts-nocheck
/**
 * AUTO-GENERATED API CLIENT (canonical - @pki-pwa/api-client)
 * Generated from OpenAPI specification
 * DO NOT EDIT MANUALLY - Use 'npm run generate:api' to regenerate
 * 
 * This file provides type-safe API calls based on your backend OpenAPI spec.
 * All functions are backward compatible with existing API calls.
 */

import { getAxios } from './axios.js';


/**
 * GET /
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const get = async (options) => {
    const path = `/`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/health
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiHealth = async (options) => {
    const path = `/api/health`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/auth/send-otp
 * 
 * @request
 * @param {SendOtpDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAuthSendOtp = async (data, options) => {
    const path = `/api/auth/send-otp`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/auth/verify-otp
 * 
 * @request
 * @param {VerifyOtpDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAuthVerifyOtp = async (data, options) => {
    const path = `/api/auth/verify-otp`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/auth/mfa/passkey-options
 * 
 * @request
 * @param {Object} data - Request body ({ pendingToken })
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, options?: any, message?: string, error?: string}>}
 */
export const postApiAuthMfaPasskeyOptions = async (data, options) => {
    const path = `/api/auth/mfa/passkey-options`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/auth/mfa/complete
 * 
 * @request
 * @param {Object} data - Request body ({ pendingToken, factor, code?, response? })
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, token?: string, user?: any, message?: string, error?: string}>}
 */
export const postApiAuthMfaComplete = async (data, options) => {
    const path = `/api/auth/mfa/complete`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/auth/complete-profile
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAuthCompleteProfile = async (options) => {
    const path = `/api/auth/complete-profile`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/auth/logout
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAuthLogout = async (options) => {
    const path = `/api/auth/logout`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/auth/verify
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAuthVerify = async (options) => {
    const path = `/api/auth/verify`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/profile
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserProfile = async (options) => {
    const path = `/api/user/profile`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/user/profile
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const patchApiUserProfile = async (options) => {
    const path = `/api/user/profile`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/profile/avatar
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiUserProfileAvatar = async (options) => {
    const path = `/api/user/profile/avatar`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get user activity logs
 * 
 * @request
 * @param {string} actionType - Query parameter (optional)
 * @param {string} startDate - Query parameter (optional)
 * @param {string} endDate - Query parameter (optional)
 * @param {number} limit - Query parameter (optional)
 * @param {number} offset - Query parameter (optional)
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserActivityLogs = async (actionType, actionTypePrefix, startDate, endDate, limit, offset, options) => {
    const path = `/api/user/activity-logs`;
    
    const queryParams = new URLSearchParams();
    if (actionType !== undefined) queryParams.append('actionType', actionType);
    if (actionTypePrefix !== undefined) queryParams.append('actionTypePrefix', actionTypePrefix);
    if (startDate !== undefined) queryParams.append('startDate', startDate);
    if (endDate !== undefined) queryParams.append('endDate', endDate);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (offset !== undefined) queryParams.append('offset', offset);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * List notification templates
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminNotificationTemplates = async (options) => {
    const path = `/api/admin/notification-templates`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Create a new notification template (draft)
 * 
 * @request
 * @param {CreateNotificationTemplateDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminNotificationTemplates = async (data, options) => {
    const path = `/api/admin/notification-templates`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get notification metadata (categories, channels, statuses, labels)
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminNotificationTemplatesMeta = async (options) => {
    const path = `/api/admin/notification-templates/meta`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get a notification template by id
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminNotificationTemplates1 = async (id, options) => {
    const path = `/api/admin/notification-templates/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Update a notification template (creates a new version when published)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {UpdateNotificationTemplateDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminNotificationTemplates = async (id, data, options) => {
    const path = `/api/admin/notification-templates/${id}`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * List all versions of a notification template key
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminNotificationTemplatesVersions = async (id, options) => {
    const path = `/api/admin/notification-templates/${id}/versions`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Submit template for approval
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminNotificationTemplatesSubmit = async (id, options) => {
    const path = `/api/admin/notification-templates/${id}/submit`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Approve a pending template
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminNotificationTemplatesApprove = async (id, options) => {
    const path = `/api/admin/notification-templates/${id}/approve`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Publish an approved template
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminNotificationTemplatesPublish = async (id, options) => {
    const path = `/api/admin/notification-templates/${id}/publish`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Render a template with sample variables
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {PreviewNotificationTemplateDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminNotificationTemplatesPreview = async (id, data, options) => {
    const path = `/api/admin/notification-templates/${id}/preview`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * List sent notification messages (admin)
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminNotifications = async (options) => {
    const path = `/api/admin/notifications`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * List sent notification messages (operator)
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperatorNotifications = async (options) => {
    const path = `/api/operator/notifications`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get my in-app notifications
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserNotifications = async (options) => {
    const path = `/api/user/notifications`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get unread notification count
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserNotificationsUnreadCount = async (options) => {
    const path = `/api/user/notifications/unread-count`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Mark a notification as read
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiUserNotificationsRead = async (id, options) => {
    const path = `/api/user/notifications/${id}/read`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Mark all my notifications as read
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiUserNotificationsReadAll = async (options) => {
    const path = `/api/user/notifications/read-all`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get notification preference matrix for current user
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserNotificationPreferences = async (options) => {
    const path = `/api/user/notification-preferences`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Update notification preferences (mandatory categories are enforced)
 * 
 * @request
 * @param {UpdateNotificationPreferencesDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const putApiUserNotificationPreferences = async (data, options) => {
    const path = `/api/user/notification-preferences`;
    const url = path;
    
    const config = {
        method: 'PUT',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/dashboard
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminOperationsDashboard = async (options) => {
    const path = `/api/admin/operations/dashboard`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/queue
 * 
 * @request
 * @param {string} status - Query parameter
 * @param {string} operationType - Query parameter
 * @param {string} provider - Query parameter
 * @param {string} limit - Query parameter
 * @param {string} offset - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminOperationsQueue = async (status, operationType, provider, limit, offset, options) => {
    const path = `/api/admin/operations/queue`;
    
    const queryParams = new URLSearchParams();
    if (status !== undefined) queryParams.append('status', status);
    if (operationType !== undefined) queryParams.append('operationType', operationType);
    if (provider !== undefined) queryParams.append('provider', provider);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (offset !== undefined) queryParams.append('offset', offset);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/queue/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminOperationsQueue1 = async (id, options) => {
    const path = `/api/admin/operations/queue/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/queue/{id}/retry
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminOperationsQueueRetry = async (id, options) => {
    const path = `/api/admin/operations/queue/${id}/retry`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/queue/{id}/cancel
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminOperationsQueueCancel = async (id, options) => {
    const path = `/api/admin/operations/queue/${id}/cancel`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/dlq
 * 
 * @request
 * @param {string} status - Query parameter
 * @param {string} limit - Query parameter
 * @param {string} offset - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminOperationsDlq = async (status, limit, offset, options) => {
    const path = `/api/admin/operations/dlq`;
    
    const queryParams = new URLSearchParams();
    if (status !== undefined) queryParams.append('status', status);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (offset !== undefined) queryParams.append('offset', offset);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/dlq/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminOperationsDlq1 = async (id, options) => {
    const path = `/api/admin/operations/dlq/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/dlq/{id}/retry
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminOperationsDlqRetry = async (id, options) => {
    const path = `/api/admin/operations/dlq/${id}/retry`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/dlq/{id}/resolve
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminOperationsDlqResolve = async (id, options) => {
    const path = `/api/admin/operations/dlq/${id}/resolve`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/compensation
 * 
 * @request
 * @param {string} status - Query parameter
 * @param {string} jobType - Query parameter
 * @param {string} limit - Query parameter
 * @param {string} offset - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminOperationsCompensation = async (status, jobType, limit, offset, options) => {
    const path = `/api/admin/operations/compensation`;
    
    const queryParams = new URLSearchParams();
    if (status !== undefined) queryParams.append('status', status);
    if (jobType !== undefined) queryParams.append('jobType', jobType);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (offset !== undefined) queryParams.append('offset', offset);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/compensation/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminOperationsCompensation1 = async (id, options) => {
    const path = `/api/admin/operations/compensation/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operations/health
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminOperationsHealth = async (options) => {
    const path = `/api/admin/operations/health`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/health/{provider}/open
 * 
 * @request
 * @param {string} provider - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminOperationsHealthOpen = async (provider, options) => {
    const path = `/api/admin/operations/health/${provider}/open`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/health/{provider}/close
 * 
 * @request
 * @param {string} provider - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminOperationsHealthClose = async (provider, options) => {
    const path = `/api/admin/operations/health/${provider}/close`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/health/{provider}/enable
 * 
 * @request
 * @param {string} provider - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminOperationsHealthEnable = async (provider, options) => {
    const path = `/api/admin/operations/health/${provider}/enable`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operations/health/{provider}/policy
 * 
 * @request
 * @param {string} provider - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminOperationsHealthPolicy = async (provider, options) => {
    const path = `/api/admin/operations/health/${provider}/policy`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operations/degradation
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperationsDegradation = async (options) => {
    const path = `/api/operations/degradation`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operations/mine
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperationsMine = async (options) => {
    const path = `/api/operations/mine`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/payments/callback
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiPaymentsCallback = async (options) => {
    const path = `/api/payments/callback`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/payments/link/{accessToken}
 * 
 * @request
 * @param {string} accessToken - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const getApiPaymentsLink = async (accessToken, options) => {
    const path = `/api/payments/link/${accessToken}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/payments/link/{accessToken}/select-product
 * 
 * @request
 * @param {string} accessToken - Path parameter
 * @param {SelectProductForPaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiPaymentsLinkSelectProduct = async (accessToken, data, options) => {
    const path = `/api/payments/link/${accessToken}/select-product`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/payments/requirement
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserPaymentsRequirement = async (options) => {
    const path = `/api/user/payments/requirement`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/payments/certificate-payment
 * 
 * @request
 * @param {RequireCertificatePaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiUserPaymentsCertificatePayment = async (data, options) => {
    const path = `/api/user/payments/certificate-payment`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/payments
 * 
 * @request
 * @param {CreatePaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiUserPayments = async (data, options) => {
    const path = `/api/user/payments`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/payments
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserPayments = async (options) => {
    const path = `/api/user/payments`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/payments/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiUserPayments1 = async (id, options) => {
    const path = `/api/user/payments/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/payments/{id}/continue
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserPaymentsContinue = async (id, options) => {
    const path = `/api/user/payments/${id}/continue`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/payments/{id}/retry
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserPaymentsRetry = async (id, options) => {
    const path = `/api/user/payments/${id}/retry`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/payments/{id}/cancel
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserPaymentsCancel = async (id, options) => {
    const path = `/api/user/payments/${id}/cancel`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/payments/{id}/offline-submit
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {SubmitOfflinePaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserPaymentsOfflineSubmit = async (id, data, options) => {
    const path = `/api/user/payments/${id}/offline-submit`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/payments/{id}/evidence
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserPaymentsEvidence = async (id, options) => {
    const path = `/api/user/payments/${id}/evidence`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/payments
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminPayments = async (options) => {
    const path = `/api/admin/payments`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/payments/reconciliation
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminPaymentsReconciliation = async (options) => {
    const path = `/api/admin/payments/reconciliation`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/payments/failed
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminPaymentsFailed = async (options) => {
    const path = `/api/admin/payments/failed`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/payments/offline
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminPaymentsOffline = async (options) => {
    const path = `/api/admin/payments/offline`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/payments/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminPayments1 = async (id, options) => {
    const path = `/api/admin/payments/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/payments/{id}/audit
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminPaymentsAudit = async (id, options) => {
    const path = `/api/admin/payments/${id}/audit`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/payments/{id}/link
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminPaymentsLink = async (id, options) => {
    const path = `/api/admin/payments/${id}/link`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/{id}/reconcile
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminPaymentsReconcile = async (id, options) => {
    const path = `/api/admin/payments/${id}/reconcile`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/reconcile
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminPaymentsReconcile1 = async (options) => {
    const path = `/api/admin/payments/reconcile`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/{id}/manual-verify
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ManualVerifyDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminPaymentsManualVerify = async (id, data, options) => {
    const path = `/api/admin/payments/${id}/manual-verify`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/{id}/refund
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {RefundPaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminPaymentsRefund = async (id, data, options) => {
    const path = `/api/admin/payments/${id}/refund`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/compensate
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminPaymentsCompensate = async (options) => {
    const path = `/api/admin/payments/compensate`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/send-link
 * 
 * @request
 * @param {SendPaymentLinkDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminPaymentsSendLink = async (data, options) => {
    const path = `/api/admin/payments/send-link`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/{id}/offline-submit
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {SubmitOfflinePaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminPaymentsOfflineSubmit = async (id, data, options) => {
    const path = `/api/admin/payments/${id}/offline-submit`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/{id}/evidence
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminPaymentsEvidence = async (id, options) => {
    const path = `/api/admin/payments/${id}/evidence`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/{id}/offline-approve
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ApproveOfflinePaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminPaymentsOfflineApprove = async (id, data, options) => {
    const path = `/api/admin/payments/${id}/offline-approve`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/payments/{id}/offline-reject
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {RejectOfflinePaymentDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminPaymentsOfflineReject = async (id, data, options) => {
    const path = `/api/admin/payments/${id}/offline-reject`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/billing/records
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: Record[], message?: string, error?: string}>}
 */
export const getApiUserBillingRecords = async (options) => {
    const path = `/api/user/billing/records`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/billing/balance
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserBillingBalance = async (options) => {
    const path = `/api/user/billing/balance`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/billing/records
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: Record[], message?: string, error?: string}>}
 */
export const getApiAdminBillingRecords = async (options) => {
    const path = `/api/admin/billing/records`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/billing/add-credit
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiUserBillingAddCredit = async (options) => {
    const path = `/api/user/billing/add-credit`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/feature-flags
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminFeatureFlags = async (options) => {
    const path = `/api/admin/feature-flags`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/feature-flags/{name}
 * 
 * @request
 * @param {string} name - Path parameter
 * @param {UpdateFeatureFlagDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const patchApiAdminFeatureFlags = async (name, data, options) => {
    const path = `/api/admin/feature-flags/${name}`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/products
 * 
 * @request
 * @param {number} page - Query parameter
 * @param {number} limit - Query parameter
 * @param {string} search - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiProducts = async (page, limit, search, options) => {
    const path = `/api/products`;
    
    const queryParams = new URLSearchParams();
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (search !== undefined) queryParams.append('search', search);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/products/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiProducts1 = async (id, options) => {
    const path = `/api/products/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/products
 * 
 * @request
 * @param {number} page - Query parameter
 * @param {number} limit - Query parameter
 * @param {string} status - Query parameter
 * @param {string} search - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminProducts = async (page, limit, status, search, options) => {
    const path = `/api/admin/products`;
    
    const queryParams = new URLSearchParams();
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (status !== undefined) queryParams.append('status', status);
    if (search !== undefined) queryParams.append('search', search);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/products
 * 
 * @request
 * @param {CreateProductDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminProducts = async (data, options) => {
    const path = `/api/admin/products`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/products/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminProducts1 = async (id, options) => {
    const path = `/api/admin/products/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PUT /api/admin/products/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {UpdateProductDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const putApiAdminProducts = async (id, data, options) => {
    const path = `/api/admin/products/${id}`;
    const url = path;
    
    const config = {
        method: 'PUT',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/admin/products/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const deleteApiAdminProducts = async (id, options) => {
    const path = `/api/admin/products/${id}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/settings
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminSettings = async (options) => {
    const path = `/api/admin/settings`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PUT /api/admin/settings/{key}
 * 
 * @request
 * @param {string} key - Path parameter
 * @param {UpdateSettingDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const putApiAdminSettings = async (key, data, options) => {
    const path = `/api/admin/settings/${key}`;
    const url = path;
    
    const config = {
        method: 'PUT',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Upload a document evidence file
 * 
 * @request
 * @param {Object} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEvidenceUpload = async (data, options) => {
    const path = `/api/evidence/upload`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * List current user document evidences
 * 
 * @request
 * @param {string} evidenceType - Query parameter
 * @param {string} linkedEntityType - Query parameter
 * @param {string} linkedEntityId - Query parameter
 * @param {string} reviewStatus - Query parameter
 * @param {string} page - Query parameter
 * @param {string} limit - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiEvidence = async (evidenceType, linkedEntityType, linkedEntityId, reviewStatus, page, limit, options) => {
    const path = `/api/evidence`;
    
    const queryParams = new URLSearchParams();
    if (evidenceType !== undefined) queryParams.append('evidenceType', evidenceType);
    if (linkedEntityType !== undefined) queryParams.append('linkedEntityType', linkedEntityType);
    if (linkedEntityId !== undefined) queryParams.append('linkedEntityId', linkedEntityId);
    if (reviewStatus !== undefined) queryParams.append('reviewStatus', reviewStatus);
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get evidence detail (own evidence)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiEvidence1 = async (id, options) => {
    const path = `/api/evidence/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Download evidence file (permission-gated)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiEvidenceDownload = async (id, options) => {
    const path = `/api/evidence/${id}/download`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Replace a rejected/expired evidence with a new file
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiEvidenceReplace = async (id, data, options) => {
    const path = `/api/evidence/${id}/replace`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * List document evidences for review (Admin/Operator)
 * 
 * @request
 * @param {string} reviewStatus - Query parameter
 * @param {string} evidenceType - Query parameter
 * @param {string} linkedEntityType - Query parameter
 * @param {string} linkedEntityId - Query parameter
 * @param {string} page - Query parameter
 * @param {string} limit - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperatorEvidence = async (reviewStatus, evidenceType, linkedEntityType, linkedEntityId, page, limit, options) => {
    const path = `/api/operator/evidence`;
    
    const queryParams = new URLSearchParams();
    if (reviewStatus !== undefined) queryParams.append('reviewStatus', reviewStatus);
    if (evidenceType !== undefined) queryParams.append('evidenceType', evidenceType);
    if (linkedEntityType !== undefined) queryParams.append('linkedEntityType', linkedEntityType);
    if (linkedEntityId !== undefined) queryParams.append('linkedEntityId', linkedEntityId);
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get evidence detail for review
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiOperatorEvidence1 = async (id, options) => {
    const path = `/api/operator/evidence/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Download evidence file (Admin/Operator)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiOperatorEvidenceDownload = async (id, options) => {
    const path = `/api/operator/evidence/${id}/download`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Start review of an evidence (Admin/Operator)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {StartReviewDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorEvidenceStartReview = async (id, data, options) => {
    const path = `/api/operator/evidence/${id}/start-review`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Approve an evidence (Admin/Operator)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ApproveEvidenceDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorEvidenceApprove = async (id, data, options) => {
    const path = `/api/operator/evidence/${id}/approve`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Reject an evidence (Admin/Operator)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {RejectEvidenceDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorEvidenceReject = async (id, data, options) => {
    const path = `/api/operator/evidence/${id}/reject`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Archive an evidence (Admin/Operator)
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorEvidenceArchive = async (id, options) => {
    const path = `/api/operator/evidence/${id}/archive`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/security/sessions
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiSecuritySessions = async (options) => {
    const path = `/api/security/sessions`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/security/sessions/{sessionId}
 * 
 * @request
 * @param {string} sessionId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const deleteApiSecuritySessions = async (sessionId, options) => {
    const path = `/api/security/sessions/${sessionId}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/sessions/terminate-all
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecuritySessionsTerminateAll = async (options) => {
    const path = `/api/security/sessions/terminate-all`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/security/devices
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiSecurityDevices = async (options) => {
    const path = `/api/security/devices`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/security/devices/{deviceId}
 * 
 * @request
 * @param {string} deviceId - Path parameter
 * @param {DeviceActionDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const patchApiSecurityDevices = async (deviceId, data, options) => {
    const path = `/api/security/devices/${deviceId}`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/security/mfa/status
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiSecurityMfaStatus = async (options) => {
    const path = `/api/security/mfa/status`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/mfa/totp/setup
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityMfaTotpSetup = async (options) => {
    const path = `/api/security/mfa/totp/setup`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/mfa/totp/verify
 * 
 * @request
 * @param {VerifyTotpDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityMfaTotpVerify = async (data, options) => {
    const path = `/api/security/mfa/totp/verify`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/security/mfa/totp
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const deleteApiSecurityMfaTotp = async (options) => {
    const path = `/api/security/mfa/totp`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/mfa/verify
 * 
 * @request
 * @param {VerifyFactorDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityMfaVerify = async (data, options) => {
    const path = `/api/security/mfa/verify`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/security/passkeys
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiSecurityPasskeys = async (options) => {
    const path = `/api/security/passkeys`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/security/passkeys/registration-options
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiSecurityPasskeysRegistrationOptions = async (options) => {
    const path = `/api/security/passkeys/registration-options`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/passkeys/registration
 * 
 * @request
 * @param {RegisterPasskeyDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityPasskeysRegistration = async (data, options) => {
    const path = `/api/security/passkeys/registration`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/security/passkeys/{passkeyId}
 * 
 * @request
 * @param {string} passkeyId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const deleteApiSecurityPasskeys = async (passkeyId, options) => {
    const path = `/api/security/passkeys/${passkeyId}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/passkeys/authentication-options
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityPasskeysAuthenticationOptions = async (options) => {
    const path = `/api/security/passkeys/authentication-options`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/passkeys/authentication
 * 
 * @request
 * @param {AuthenticatePasskeyDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityPasskeysAuthentication = async (data, options) => {
    const path = `/api/security/passkeys/authentication`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/recovery-codes/generate
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityRecoveryCodesGenerate = async (options) => {
    const path = `/api/security/recovery-codes/generate`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/security/recovery-codes/status
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiSecurityRecoveryCodesStatus = async (options) => {
    const path = `/api/security/recovery-codes/status`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/security/recovery-codes/verify
 * 
 * @request
 * @param {VerifyFactorDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiSecurityRecoveryCodesVerify = async (data, options) => {
    const path = `/api/security/recovery-codes/verify`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/security/events
 * 
 * @request
 * @param {string} type - Query parameter
 * @param {string} limit - Query parameter
 * @param {string} offset - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiSecurityEvents = async (type, limit, offset, options) => {
    const path = `/api/security/events`;
    
    const queryParams = new URLSearchParams();
    if (type !== undefined) queryParams.append('type', type);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (offset !== undefined) queryParams.append('offset', offset);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/certificates/issue
 * 
 * @request
 * @param {IssueCertificateDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiCertificatesIssue = async (data, options) => {
    const path = `/api/certificates/issue`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/certificates/my-certificates
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiCertificatesMyCertificates = async (options) => {
    const path = `/api/certificates/my-certificates`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/certificates/stored
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiCertificatesStored = async (options) => {
    const path = `/api/certificates/stored`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/certificates/revoke
 * 
 * @request
 * @param {RevokeCertificateDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiCertificatesRevoke = async (data, options) => {
    const path = `/api/certificates/revoke`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/pdf/sign
 * 
 * @request
 * @param {SignPdfDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiPdfSign = async (data, options) => {
    const path = `/api/pdf/sign`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/pdf/sign-epass
 * 
 * @request
 * @param {SignEpassDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiPdfSignEpass = async (data, options) => {
    const path = `/api/pdf/sign-epass`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/pdf/verify
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiPdfVerify = async (options) => {
    const path = `/api/pdf/verify`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/pdf/history
 * 
 * @request
 * @param {string} limit - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiPdfHistory = async (limit, options) => {
    const path = `/api/pdf/history`;
    
    const queryParams = new URLSearchParams();
    if (limit !== undefined) queryParams.append('limit', limit);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/pdf/documents/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: Document}>}
 */
export const getApiPdfDocuments = async (id, options) => {
    const path = `/api/pdf/documents/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/pdf/documents/{id}/download
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiPdfDocumentsDownload = async (id, options) => {
    const path = `/api/pdf/documents/${id}/download`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/pdf/stats
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, stats: Object}>}
 */
export const getApiPdfStats = async (options) => {
    const path = `/api/pdf/stats`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/auth/login
 * 
 * @request
 * @param {AdminLoginDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminAuthLogin = async (data, options) => {
    const path = `/api/admin/auth/login`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/auth/logout
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminAuthLogout = async (options) => {
    const path = `/api/admin/auth/logout`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/auth/verify
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminAuthVerify = async (options) => {
    const path = `/api/admin/auth/verify`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/auth/me
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminAuthMe = async (options) => {
    const path = `/api/admin/auth/me`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/auth/me
 * 
 * @request
 * @param {UpdateAdminProfileDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const patchApiAdminAuthMe = async (data, options) => {
    const path = `/api/admin/auth/me`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/auth/me/avatar
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminAuthMeAvatar = async (options) => {
    const path = `/api/admin/auth/me/avatar`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operators
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: Operator, message?: string, error?: string}>}
 */
export const postApiAdminOperators = async (options) => {
    const path = `/api/admin/operators`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operators
 * 
 * @request
 * @param {string} role - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: Operator[], message?: string, error?: string}>}
 */
export const getApiAdminOperators = async (role, options) => {
    const path = `/api/admin/operators`;
    
    const queryParams = new URLSearchParams();
    if (role !== undefined) queryParams.append('role', role);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/operators/{id}/status
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminOperatorsStatus = async (id, options) => {
    const path = `/api/admin/operators/${id}/status`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operators/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: Operator}>}
 */
export const getApiAdminOperators1 = async (id, options) => {
    const path = `/api/admin/operators/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/operators/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: Operator}>}
 */
export const patchApiAdminOperators = async (id, options) => {
    const path = `/api/admin/operators/${id}`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/operators/{id}/delete
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminOperatorsDelete = async (id, options) => {
    const path = `/api/admin/operators/${id}/delete`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/operators/{id}/stats
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, stats: Object}>}
 */
export const getApiAdminOperatorsStats = async (id, options) => {
    const path = `/api/admin/operators/${id}/stats`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/users
 * 
 * @request
 * @param {string} page - Query parameter
 * @param {string} limit - Query parameter
 * @param {string} sortBy - Query parameter
 * @param {string} sortOrder - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: User[], message?: string, error?: string}>}
 */
export const getApiAdminUsers = async (page, limit, sortBy, sortOrder, options) => {
    const path = `/api/admin/users`;
    
    const queryParams = new URLSearchParams();
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (sortBy !== undefined) queryParams.append('sortBy', sortBy);
    if (sortOrder !== undefined) queryParams.append('sortOrder', sortOrder);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/users/search
 * 
 * @request
 * @param {string} q - Query parameter
 * @param {string} searchBy - Query parameter
 * @param {string} page - Query parameter
 * @param {string} limit - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any[], pagination?: any}>}
 */
export const getApiAdminUsersSearch = async (q, searchBy, page, limit, options) => {
    const path = `/api/admin/users/search`;
    
    const queryParams = new URLSearchParams();
    if (q !== undefined) queryParams.append('q', q);
    if (searchBy !== undefined) queryParams.append('searchBy', searchBy);
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/users/stats
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, stats: Object}>}
 */
export const getApiAdminUsersStats = async (options) => {
    const path = `/api/admin/users/stats`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/users/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: User}>}
 */
export const getApiAdminUsers1 = async (id, options) => {
    const path = `/api/admin/users/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/admin/users/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: User}>}
 */
export const deleteApiAdminUsers = async (id, options) => {
    const path = `/api/admin/users/${id}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/users/{id}/status
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminUsersStatus = async (id, options) => {
    const path = `/api/admin/users/${id}/status`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/users/{id}/login-as
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminUsersLoginAs = async (id, options) => {
    const path = `/api/admin/users/${id}/login-as`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/certificates
 * 
 * @request
 * @param {number} page - Query parameter
 * @param {number} limit - Query parameter
 * @param {string} status - Query parameter
 * @param {number} userId - Query parameter
 * @param {string} serialNumber - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: Certificate[], message?: string, error?: string}>}
 */
export const getApiAdminCertificates = async (page, limit, status, userId, serialNumber, options) => {
    const path = `/api/admin/certificates`;
    
    const queryParams = new URLSearchParams();
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (status !== undefined) queryParams.append('status', status);
    if (userId !== undefined) queryParams.append('userId', userId);
    if (serialNumber !== undefined) queryParams.append('serialNumber', serialNumber);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/certificates/search
 * 
 * @request
 * @param {string} q - Query parameter
 * @param {number} page - Query parameter
 * @param {number} limit - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any[], pagination?: any}>}
 */
export const getApiAdminCertificatesSearch = async (q, page, limit, options) => {
    const path = `/api/admin/certificates/search`;
    
    const queryParams = new URLSearchParams();
    if (q !== undefined) queryParams.append('q', q);
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/certificates/user/{userId}/install-info
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const getApiAdminCertificatesUserInstallInfo = async (userId, options) => {
    const path = `/api/admin/certificates/user/${userId}/install-info`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/certificates/user/{userId}/issue-from-token
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {IssueCertificateFromTokenDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminCertificatesUserIssueFromToken = async (userId, data, options) => {
    const path = `/api/admin/certificates/user/${userId}/issue-from-token`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/certificates/{id}/revoke
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {RevokeCertificateDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminCertificatesRevoke = async (id, data, options) => {
    const path = `/api/admin/certificates/${id}/revoke`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/profiles/import
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminProfilesImport = async (options) => {
    const path = `/api/admin/profiles/import`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/profiles
 * 
 * @request
 * @param {number} page - Query parameter
 * @param {number} limit - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminProfiles = async (page, limit, options) => {
    const path = `/api/admin/profiles`;
    
    const queryParams = new URLSearchParams();
    if (page !== undefined) queryParams.append('page', page);
    if (limit !== undefined) queryParams.append('limit', limit);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/profiles
 * 
 * @request
 * @param {CreateProfileDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminProfiles = async (data, options) => {
    const path = `/api/admin/profiles`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/profiles/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminProfiles1 = async (id, options) => {
    const path = `/api/admin/profiles/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PUT /api/admin/profiles/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {UpdateProfileDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const putApiAdminProfiles = async (id, data, options) => {
    const path = `/api/admin/profiles/${id}`;
    const url = path;
    
    const config = {
        method: 'PUT',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/admin/profiles/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const deleteApiAdminProfiles = async (id, options) => {
    const path = `/api/admin/profiles/${id}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/profiles/code/{code}
 * 
 * @request
 * @param {string} code - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const getApiAdminProfilesCode = async (code, options) => {
    const path = `/api/admin/profiles/code/${code}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/profiles/{id}/activate
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminProfilesActivate = async (id, options) => {
    const path = `/api/admin/profiles/${id}/activate`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/profiles/{id}/deactivate
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminProfilesDeactivate = async (id, options) => {
    const path = `/api/admin/profiles/${id}/deactivate`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/profiles/{id}/extra-costs
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminProfilesExtraCosts = async (id, options) => {
    const path = `/api/admin/profiles/${id}/extra-costs`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/profiles/{id}/extra-costs
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {AddExtraCostDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminProfilesExtraCosts = async (id, data, options) => {
    const path = `/api/admin/profiles/${id}/extra-costs`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/user-groups
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminUserGroups = async (options) => {
    const path = `/api/admin/user-groups`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/user-groups
 * 
 * @request
 * @param {CreateUserGroupDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminUserGroups = async (data, options) => {
    const path = `/api/admin/user-groups`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/user-groups/default
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminUserGroupsDefault = async (options) => {
    const path = `/api/admin/user-groups/default`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/user-groups/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminUserGroups1 = async (id, options) => {
    const path = `/api/admin/user-groups/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PUT /api/admin/user-groups/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {UpdateUserGroupDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const putApiAdminUserGroups = async (id, data, options) => {
    const path = `/api/admin/user-groups/${id}`;
    const url = path;
    
    const config = {
        method: 'PUT',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/admin/user-groups/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const deleteApiAdminUserGroups = async (id, options) => {
    const path = `/api/admin/user-groups/${id}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/user-groups/{id}/profile
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {SetGroupProfileDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminUserGroupsProfile = async (id, data, options) => {
    const path = `/api/admin/user-groups/${id}/profile`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/user-groups/{id}/activate
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminUserGroupsActivate = async (id, options) => {
    const path = `/api/admin/user-groups/${id}/activate`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/user-groups/{id}/deactivate
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminUserGroupsDeactivate = async (id, options) => {
    const path = `/api/admin/user-groups/${id}/deactivate`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/activity-logs
 * 
 * @request
 * @param {string} userId - Query parameter
 * @param {string} adminId - Query parameter
 * @param {string} actionType - Query parameter
 * @param {string} startDate - Query parameter
 * @param {string} endDate - Query parameter
 * @param {string} limit - Query parameter
 * @param {string} offset - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminActivityLogs = async (userId, adminId, actionType, actionTypePrefix, startDate, endDate, limit, offset, options) => {
    const path = `/api/admin/activity-logs`;
    
    const queryParams = new URLSearchParams();
    if (userId !== undefined) queryParams.append('userId', userId);
    if (adminId !== undefined) queryParams.append('adminId', adminId);
    if (actionType !== undefined) queryParams.append('actionType', actionType);
    if (actionTypePrefix !== undefined) queryParams.append('actionTypePrefix', actionTypePrefix);
    if (startDate !== undefined) queryParams.append('startDate', startDate);
    if (endDate !== undefined) queryParams.append('endDate', endDate);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (offset !== undefined) queryParams.append('offset', offset);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/activity-logs/export
 * 
 * @request
 * @param {string} userId - Query parameter
 * @param {string} adminId - Query parameter
 * @param {string} actionType - Query parameter
 * @param {string} startDate - Query parameter
 * @param {string} endDate - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminActivityLogsExport = async (userId, adminId, actionType, startDate, endDate, options) => {
    const path = `/api/admin/activity-logs/export`;
    
    const queryParams = new URLSearchParams();
    if (userId !== undefined) queryParams.append('userId', userId);
    if (adminId !== undefined) queryParams.append('adminId', adminId);
    if (actionType !== undefined) queryParams.append('actionType', actionType);
    if (startDate !== undefined) queryParams.append('startDate', startDate);
    if (endDate !== undefined) queryParams.append('endDate', endDate);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * Get operator activity logs
 * 
 * @request
 * @param {string} actionType - Query parameter (optional)
 * @param {string} startDate - Query parameter (optional)
 * @param {string} endDate - Query parameter (optional)
 * @param {number} limit - Query parameter (optional)
 * @param {number} offset - Query parameter (optional)
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperatorActivityLogs = async (actionType, actionTypePrefix, startDate, endDate, limit, offset, options) => {
    const path = `/api/operator/activity-logs`;
    
    const queryParams = new URLSearchParams();
    if (actionType !== undefined) queryParams.append('actionType', actionType);
    if (actionTypePrefix !== undefined) queryParams.append('actionTypePrefix', actionTypePrefix);
    if (startDate !== undefined) queryParams.append('startDate', startDate);
    if (endDate !== undefined) queryParams.append('endDate', endDate);
    if (limit !== undefined) queryParams.append('limit', limit);
    if (offset !== undefined) queryParams.append('offset', offset);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/tickets
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiUserTickets = async (options) => {
    const path = `/api/user/tickets`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/tickets
 * 
 * @request
 * @param {CreateTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiUserTickets = async (data, options) => {
    const path = `/api/user/tickets`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/tickets/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiUserTickets1 = async (id, options) => {
    const path = `/api/user/tickets/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/user/tickets/{id}/link-search
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any[], pagination?: any}>}
 */
export const getApiUserTicketsLinkSearch = async (id, options) => {
    const path = `/api/user/tickets/${id}/link-search`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/tickets/{id}/reply
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ReplyTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserTicketsReply = async (id, data, options) => {
    const path = `/api/user/tickets/${id}/reply`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/tickets/{id}/evidence
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserTicketsEvidence = async (id, options) => {
    const path = `/api/user/tickets/${id}/evidence`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/user/tickets/{id}/messages/{messageId}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {string} messageId - Path parameter
 * @param {UpdateMessageDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiUserTicketsMessages = async (id, messageId, data, options) => {
    const path = `/api/user/tickets/${id}/messages/${messageId}`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/user/tickets/{id}/messages/{messageId}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {string} messageId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const deleteApiUserTicketsMessages = async (id, messageId, options) => {
    const path = `/api/user/tickets/${id}/messages/${messageId}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/user/tickets/{id}/links
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {LinkTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiUserTicketsLinks = async (id, data, options) => {
    const path = `/api/user/tickets/${id}/links`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operator/tickets
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperatorTickets = async (options) => {
    const path = `/api/operator/tickets`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/tickets
 * 
 * @request
 * @param {CreateTicketForUserDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiOperatorTickets = async (data, options) => {
    const path = `/api/operator/tickets`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operator/tickets/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiOperatorTickets1 = async (id, options) => {
    const path = `/api/operator/tickets/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operator/tickets/{id}/link-search
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any[], pagination?: any}>}
 */
export const getApiOperatorTicketsLinkSearch = async (id, options) => {
    const path = `/api/operator/tickets/${id}/link-search`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/tickets/{id}/reply
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ReplyTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorTicketsReply = async (id, data, options) => {
    const path = `/api/operator/tickets/${id}/reply`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/tickets/{id}/escalate
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {EscalateTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorTicketsEscalate = async (id, data, options) => {
    const path = `/api/operator/tickets/${id}/escalate`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/tickets/{id}/evidence
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorTicketsEvidence = async (id, options) => {
    const path = `/api/operator/tickets/${id}/evidence`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/operator/tickets/{id}/messages/{messageId}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {string} messageId - Path parameter
 * @param {UpdateMessageDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiOperatorTicketsMessages = async (id, messageId, data, options) => {
    const path = `/api/operator/tickets/${id}/messages/${messageId}`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/operator/tickets/{id}/messages/{messageId}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {string} messageId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const deleteApiOperatorTicketsMessages = async (id, messageId, options) => {
    const path = `/api/operator/tickets/${id}/messages/${messageId}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/tickets/{id}/links
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {LinkTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiOperatorTicketsLinks = async (id, data, options) => {
    const path = `/api/operator/tickets/${id}/links`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/tickets
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiAdminTickets = async (options) => {
    const path = `/api/admin/tickets`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/tickets
 * 
 * @request
 * @param {CreateTicketForUserDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiAdminTickets = async (data, options) => {
    const path = `/api/admin/tickets`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/tickets/{id}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminTickets1 = async (id, options) => {
    const path = `/api/admin/tickets/${id}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/tickets/{id}/link-search
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any[], pagination?: any}>}
 */
export const getApiAdminTicketsLinkSearch = async (id, options) => {
    const path = `/api/admin/tickets/${id}/link-search`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/admin/tickets/{id}/audit
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const getApiAdminTicketsAudit = async (id, options) => {
    const path = `/api/admin/tickets/${id}/audit`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/tickets/{id}/reply
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ReplyTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminTicketsReply = async (id, data, options) => {
    const path = `/api/admin/tickets/${id}/reply`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/tickets/{id}/escalate
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {EscalateTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminTicketsEscalate = async (id, data, options) => {
    const path = `/api/admin/tickets/${id}/escalate`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/tickets/{id}/evidence
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminTicketsEvidence = async (id, options) => {
    const path = `/api/admin/tickets/${id}/evidence`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/tickets/{id}/messages/{messageId}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {string} messageId - Path parameter
 * @param {UpdateMessageDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminTicketsMessages = async (id, messageId, data, options) => {
    const path = `/api/admin/tickets/${id}/messages/${messageId}`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * DELETE /api/admin/tickets/{id}/messages/{messageId}
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {string} messageId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const deleteApiAdminTicketsMessages = async (id, messageId, options) => {
    const path = `/api/admin/tickets/${id}/messages/${messageId}`;
    const url = path;
    
    const config = {
        method: 'DELETE',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/tickets/{id}/links
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {LinkTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminTicketsLinks = async (id, data, options) => {
    const path = `/api/admin/tickets/${id}/links`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/tickets/{id}/status
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ChangeTicketStatusDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminTicketsStatus = async (id, data, options) => {
    const path = `/api/admin/tickets/${id}/status`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/admin/tickets/{id}/priority
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {ChangeTicketPriorityDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const patchApiAdminTicketsPriority = async (id, data, options) => {
    const path = `/api/admin/tickets/${id}/priority`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/admin/tickets/{id}/assign
 * 
 * @request
 * @param {string} id - Path parameter
 * @param {AssignTicketDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data: any}>}
 */
export const postApiAdminTicketsAssign = async (id, data, options) => {
    const path = `/api/admin/tickets/${id}/assign`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/ekyc/status
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiEkycStatus = async (options) => {
    const path = `/api/ekyc/status`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/start
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycStart = async (options) => {
    const path = `/api/ekyc/start`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/profile
 * 
 * @request
 * @param {SubmitIdentityDataDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycProfile = async (data, options) => {
    const path = `/api/ekyc/profile`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/consent
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycConsent = async (options) => {
    const path = `/api/ekyc/consent`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/sabte-ahval
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycSabteAhval = async (options) => {
    const path = `/api/ekyc/sabte-ahval`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/shahkar
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycShahkar = async (options) => {
    const path = `/api/ekyc/shahkar`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/face
 * 
 * @request
 * @param {SubmitFaceDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycFace = async (data, options) => {
    const path = `/api/ekyc/face`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/evidence
 * 
 * @request
 * @param {SubmitEvidenceDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycEvidence = async (data, options) => {
    const path = `/api/ekyc/evidence`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/card-front
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycCardFront = async (options) => {
    const path = `/api/ekyc/card-front`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/card-back
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycCardBack = async (options) => {
    const path = `/api/ekyc/card-back`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/face-video
 * 
 * @request
 * @param {UploadFaceVideoDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycFaceVideo = async (data, options) => {
    const path = `/api/ekyc/face-video`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/ekyc/complete
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiEkycComplete = async (options) => {
    const path = `/api/ekyc/complete`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/ekyc/history
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiEkycHistory = async (options) => {
    const path = `/api/ekyc/history`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/ekyc/links
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiEkycLinks = async (options) => {
    const path = `/api/ekyc/links`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/kyc-link/{token}
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const getApiKycLink = async (token, options) => {
    const path = `/api/kyc-link/${token}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/profile
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {SubmitIdentityDataDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkProfile = async (token, data, options) => {
    const path = `/api/kyc-link/${token}/profile`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/consent
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkConsent = async (token, options) => {
    const path = `/api/kyc-link/${token}/consent`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/sabte-ahval
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkSabteAhval = async (token, options) => {
    const path = `/api/kyc-link/${token}/sabte-ahval`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/shahkar
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkShahkar = async (token, options) => {
    const path = `/api/kyc-link/${token}/shahkar`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/face
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {SubmitFaceDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkFace = async (token, data, options) => {
    const path = `/api/kyc-link/${token}/face`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/evidence
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {SubmitEvidenceDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkEvidence = async (token, data, options) => {
    const path = `/api/kyc-link/${token}/evidence`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/card-front
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkCardFront = async (token, options) => {
    const path = `/api/kyc-link/${token}/card-front`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/card-back
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkCardBack = async (token, options) => {
    const path = `/api/kyc-link/${token}/card-back`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/face-video
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {UploadFaceVideoDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkFaceVideo = async (token, data, options) => {
    const path = `/api/kyc-link/${token}/face-video`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/kyc-link/{token}/complete
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiKycLinkComplete = async (token, options) => {
    const path = `/api/kyc-link/${token}/complete`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/kyc-link/{token}/evidence/{evidenceId}/download
 * 
 * @request
 * @param {string} token - Path parameter
 * @param {string} evidenceId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const getApiKycLinkEvidenceDownload = async (token, evidenceId, options) => {
    const path = `/api/kyc-link/${token}/evidence/${evidenceId}/download`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operator/ekyc/status
 * 
 * @request
 * @param {number} userId - Query parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperatorEkycStatus = async (userId, options) => {
    const path = `/api/operator/ekyc/status`;
    
    const queryParams = new URLSearchParams();
    if (userId !== undefined) queryParams.append('userId', userId);
    const queryString = queryParams.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operator/ekyc/pending-review
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperatorEkycPendingReview = async (options) => {
    const path = `/api/operator/ekyc/pending-review`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operator/ekyc/users/{userId}
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: User, message?: string, error?: string}>}
 */
export const getApiOperatorEkycUsers = async (userId, options) => {
    const path = `/api/operator/ekyc/users/${userId}`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/ekyc/links
 * 
 * @request
 * @param {SendKycLinkDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiOperatorEkycLinks = async (data, options) => {
    const path = `/api/operator/ekyc/links`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/ekyc/users/{userId}/perform
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {ManualPerformDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiOperatorEkycUsersPerform = async (userId, data, options) => {
    const path = `/api/operator/ekyc/users/${userId}/perform`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/ekyc/users/{userId}/manual-approve
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {ManualApproveDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiOperatorEkycUsersManualApprove = async (userId, data, options) => {
    const path = `/api/operator/ekyc/users/${userId}/manual-approve`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/ekyc/users/{userId}/approve-check
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {ApproveCheckDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiOperatorEkycUsersApproveCheck = async (userId, data, options) => {
    const path = `/api/operator/ekyc/users/${userId}/approve-check`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/ekyc/users/{userId}/manual-reject
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {ManualRejectDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiOperatorEkycUsersManualReject = async (userId, data, options) => {
    const path = `/api/operator/ekyc/users/${userId}/manual-reject`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * POST /api/operator/ekyc/users/{userId}/rekyc/skip
 * 
 * @request
 * @param {string} userId - Path parameter
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const postApiOperatorEkycUsersRekycSkip = async (userId, options) => {
    const path = `/api/operator/ekyc/users/${userId}/rekyc/skip`;
    const url = path;
    
    const config = {
        method: 'POST',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * GET /api/operator/ekyc/rekyc-config
 * 
 * @request
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any[], message?: string, error?: string}>}
 */
export const getApiOperatorEkycRekycConfig = async (options) => {
    const path = `/api/operator/ekyc/rekyc-config`;
    const url = path;
    
    const config = {
        method: 'GET',
        url,
        ...options,
    };
    
    
    
    const response = await getAxios()(config);
    return response.data;
};

/**
 * PATCH /api/operator/ekyc/rekyc-config
 * 
 * @request
 * @param {UpdateRekycConfigDto} data - Request body
 * @param {Object} options - Request options (optional)
 * 
 * @response
 * @returns {Promise<{success: boolean, data?: any, message?: string, error?: string}>}
 */
export const patchApiOperatorEkycRekycConfig = async (data, options) => {
    const path = `/api/operator/ekyc/rekyc-config`;
    const url = path;
    
    const config = {
        method: 'PATCH',
        url,
        ...options,
    };
    
    if (data) config.data = data;
    
    const response = await getAxios()(config);
    return response.data;
};
